import { render, staticRenderFns } from "./CustomerReward.vue?vue&type=template&id=152464ea&scoped=true&"
import script from "./CustomerReward.vue?vue&type=script&lang=ts&"
export * from "./CustomerReward.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerReward.vue?vue&type=style&index=0&id=152464ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152464ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VContainer,VProgressLinear,VRow,VSkeletonLoader})
